import { useEffect, useState } from "react";

import { ENROLLMENT_STATUS, PAYMENT_METHOD_CODE } from "consts";
import { usePolicyDetail } from "data/ss-data-hooks";
import {
  type FAQ,
  type FAQCategory,
  getFaqs,
  getPaymentMethodDetails,
  useFlags,
} from "utils";

type UseFaqsParams = {
  category?: FAQCategory;
  noUpsell?: boolean;
};

export const useFaqs = ({ category, noUpsell }: UseFaqsParams): FAQ[] => {
  const flags = useFlags();
  const supportPhoneNumber = flags.supportPhoneNumber;
  const { data } = usePolicyDetail();

  const [filteredFaqs, setFilteredFaqs] = useState<FAQ[]>([]);

  useEffect(() => {
    const { isCommercial } = data?.userDetails ?? {};
    const { accounting } = data?.userBilling ?? {};

    const paymentMethod =
      data?.userDetails.insuredPreferences?.easyPayEnrollmentStatus ===
      ENROLLMENT_STATUS.PENDING
        ? PAYMENT_METHOD_CODE.EASYPAY
        : getPaymentMethodDetails(
            accounting?.paymentPlan?.planType?.toLowerCase()
          )?.paymentMethod;

    setFilteredFaqs(
      getFaqs(supportPhoneNumber).filter((faq) => {
        return (
          (!faq.hideUnlessFlag || flags[faq.hideUnlessFlag]) &&
          !(isCommercial && faq.hideForCommercial) &&
          (!category || faq.category === category) &&
          (!faq.paymentMethods || faq.paymentMethods.includes(paymentMethod)) &&
          !(noUpsell && faq.hideIfNoUpsell)
        );
      }) ?? []
    );
  }, [
    category,
    flags,
    noUpsell,
    supportPhoneNumber,
    data?.userBilling,
    data?.userDetails,
  ]);

  return filteredFaqs;
};
